/* =============================================================================
DB:       Realtime DB
PURPOSE:  Stores dayplanner sessions
============================================================================= */

export default {
  VALID_CHECKLIST_ITEM_STATES: ['completed', 'incomplete'],

  create({ userId }, data, BACKEND) {
    return {
      dateString:         data.dateString,
      createdAt:          data.createdAt,
      from:               data.from,
      to:                 data.to,
      type:               data.type,
      fixedFrom:          data.fixedFrom || null,
      fixedTo:            data.fixedTo || null,
      fixedDuration:      data.fixedDuration || null,
      commitmentId:       data.commitmentId || null,
      tasks:              data.tasks || null,
      sequenceItems:      data.sequenceItems || null,
      sortidx:            data.sortidx || null,

      // source: manually created by user; created by optimizer; created by other user
      source:             data.source || null,

      config:             data.config || {
        // icon:
        // title:
      },
      //sharedWithUserIds:  data.sharedWithUserIds || null, // TODO
      //reminderSettings:   data.reminderSettings || null// TODO
    }
  },

  fields: {
    dateString: { validate_bolt_type: 'YYMMDDDate' },
    from: { validate_bolt_type: 'Timestamp' },
    createdAt: { validate_bolt_type: 'Timestamp' },
    to: { validate_bolt_type: 'Timestamp' },
    type: { validate_bolt_type: 'String' },
    fixedFrom: { validate_bolt_type: 'Boolean' },
    fixedTo: { validate_bolt_type: 'Boolean' },
    fixedDuration: { validate_bolt_type: 'Boolean' },
    commitmentId: { validate_bolt_type: 'AnyID' }, // TODO: PushID
    tasks: { validate_bolt_type: "UserDayplanSessionsTask[]" },
    sequenceItems: {},
    sortidx: { validate_bolt_type: 'Number' },
    source: {},
    config: { validate_bolt_type: 'Any' }, // TODO!
    'config/title': {},
    'config/icon': {},
  }
};
